import { Button, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomForm from "../CustomForm";
import { userHasLevel } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import { createPortal } from "react-dom";
import {
  modalsByContext,
  prestationAddressAlreadyExist,
} from "./modals";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { FiCheckCircle } from "react-icons/fi";
import { typeAddress } from "../../container/Addresses/AddresseItem/AddresseHelpers";
import { inputsAddresseItem } from "../../container/Addresses/AddresseItem/AddresseItemInputs";
import { newAddresse } from "../../container/Addresses/AddressesSlice/Addresses.slice";
import { addresseItemMapsInputs } from "../../container/Addresses/AddresseItem/AddresseItemMapsInputs";
import { truncateDecimal } from "../../../utils/helpersFunction";
import { http } from "../../../engine/api/http";

export const InstitutionNewAddress = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { institution } = useSelector(state => state.institution);

  const formRef = useRef(null);

  const context = useContext(ModalContext);
  const { params } = context;
  const { type } = params;
  const dispatch = useDispatch();
  const close = params => {
    setOpen(false);
    context.closeModal(modalsByContext.InstitutionNewAddress, params);
    context.setParams(context.params.oldParams, context.params.oldCallback);
  };
  const onSubmitForm = async data => {
    const allDatas = formRef.current.getFieldsValue(true);
    let payload = {};

    // handleSubmit(generateSubObject(values), form);

    if (type === typeAddress.postal) {
      payload = {
        type,
        institution: params?.institution,
        principal: params?.principal,
        description: data?.description,
        ...data?.address,
        sharedToInstitutions: data?.sharedToInstitutions || [],
      };
    }

    if (type === typeAddress.maps) {
      const allData = formRef.current.getFieldsValue(true);
      let longitude = "";
      let latitude = "";
      let canton = "";

      if (data.maps !== undefined) {
        longitude = truncateDecimal(allData?.lng_maps || 0, 5);
        latitude = truncateDecimal(allData?.lat_maps || 0, 5);
        canton = allData?.canton_maps || "";
      }

      payload = {
        type,
        institution: params?.institution,
        ...data,
        longitude,
        latitude,
        canton,
      };
    }

    const saveAndClose = async () => {
      const action = await dispatch(newAddresse(payload));
      close({ _id: action?.payload?._id, data: action?.payload });
    };

    // Doublon géographique : uniquement pour les lieux d'intervention (maps),
    // pas pour les adresses postales de facturation.
    if (type === typeAddress.maps) {
      const exist = await http.post("/addresses/exist", payload);

      if (exist.data.length > 0) {
        const ref = await prestationAddressAlreadyExist({
          content: {
            addresses: exist.data,
          },
          onOk: async () => {
            await saveAndClose();
            ref.destroy();
          },
          onCancel: async () => {},
        });
        return;
      }
    }

    await saveAndClose();
  };

  const config = {
    key: institution._id + modalsByContext.InstitutionNewAddress,
    containerStyle: { minWidth: "500px" },
    title:
      type === typeAddress.postal
        ? "Nouvelle adresse de facturation"
        : "Nouveau lieu d'intervention",
    open: open,
    width: 1000,
    onOk: () => {
      formRef.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <CustomForm
          refForm={formRef}
          dataSource={
            type === typeAddress.postal
              ? inputsAddresseItem({
                  address: {
                    beneficiary: "",
                  },
                  description: ``,
                })
              : addresseItemMapsInputs({
                  location: "",
                  maps: "",
                })
          }
          labelCol={24}
          handleSubmit={onSubmitForm}
          wrapperCol={24}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        Fermer
      </Button>,
      <Button
        icon={<FiCheckCircle size={20} />}
        type="primary"
        // loading={loadingEdit}
        // disabled={loadingEdit}
        onClick={async () => {
          try {
            const test = await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message: e.errorFields.length + " champs est nécessaire",
            });
          }
        }}
      >
        {type === typeAddress.postal && "Créer l'adresse"}
        {type === typeAddress.maps && "Créer le lieu d'intervention"}
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const prestationCommentAdminInputs = prestation => {
  const {
    intervention: { startDate, endDate, location, extra },
    comment,
  } = prestation;

  return [
    {
      hidden: !userHasLevel({
        only: {
          [roles.admin]: "crud", //
          [roles.permanance]: "crud", //
        },
      }),
      children: [
        {
          label: "Commentaire permanence",
          name: "comment.admin",
          hidden: !userHasLevel({
            only: {
              [roles.admin]: "crud", //
              [roles.permanance]: "crud", //
            },
          }),
          value: comment.admin,
          type: "textarea",
          row: 2,
          col: 24,
        },
      ],
    },
  ];
};
